<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Chuyển đơn vị quan hệ ngân sách</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Mã/Tên đơn vị:"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" placeholder="Nhập tên hoặc mã đơn vị..."
                                                  v-model="searchForm.str">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Trạng thái mã"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-model="searchForm.trangThaiMa" :options="dmdcStatuses" allowClear></select2>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Ngày tạo từ:"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.startDate" style="width:100%" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Ngày tạo đến"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.endDate" style="width:100%" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center">
                            <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                        </b-row>
                    </b-form>
                    <br />
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            dataUrl="master-data/available-national-budget-codes"
                            gridName="Danh sách mã đơn vị quan hệ ngân sách chưa chuyển"
                            ref="nationalBudgetCodeTable">
                        <template v-slot:actions>
                            <b-button type="button" variant="primary" :to="{ path: `/master-data/units?hasNBC=false` }">
                                Cập nhật đơn vị sẵn có
                            </b-button>
                        </template>
                        <template v-slot:cell(ngayTao)="row">
                            {{ row.item.ngayTao | formatDate }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <template>
                                    <b-button size="sm" v-b-modal.modal-national-budget-code-detail title="xem" @click="loadNationalBudgetCodeDetail(row.item.id)" variant="info">
                                        Xem
                                    </b-button>
                                    <b-button size="sm" :to="{ path: `/master-data/units/create?nbc=${row.item.ma}`}" title="xem" variant="primary">
                                        Chuyển đơn vị
                                    </b-button>
                                </template>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>

        <b-modal :no-enforce-focus="true" id="modal-national-budget-code-detail"
                 ref="modal"
                 size="xl"
                 no-close-on-backdrop
                 title="Thông tin chi tiết mã đơn vị quan hệ ngân sách"
                 @show="resetModal"
                 @hidden="resetModal"
                 @ok="handleOk">
            <b-form>
                <b-row>
                    <b-col sm="6">
                        <b-form-group label="Mã QHNS:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.ma }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Tên đơn vị:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.ten }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Mã cơ quan thu:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.maCqt }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Mã tham chiếu:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.maThamchieu }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Mã loại đơn vị:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.loaidvMa }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Tên loại đơn vị:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.loaidvTen }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Cấp dự toán:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.capdt }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Mã loại hình đơn vị:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.lhdvMa }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Tên loại hình đơn vị:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.lhdvTen }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Số quyết định thành lập:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.soqdTl }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Ngày thành lập:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.ngayTl | formatDate }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Cơ quan thành lập:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.coquanTl }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Mã đơn vị cấp trên:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.dvctMa }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Tên đơn vị cấp trên:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.dvctTen }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Mã đơn vị quản lý trực tiếp:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.dvqlttMa }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Tên đơn vị quản lý trực tiếp:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.dvqlttTen }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Mã địa bàn:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.dbnMa }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Tên địa bàn:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.dbnTen }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Địa chỉ:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.diachi }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Đơn vị dự toán cấp trên:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.dvdtct }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Đơn vị dự toán cấp dưới:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.dvdtcd }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Ngày tạo:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.ngayTao | formatDate }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Người tạo:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.nguoiTao }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Ngày sửa:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.ngaySua | formatDate }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Người sửa:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.nguoiSua }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Mã chương:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.chuong }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Tên chương:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.cchTen }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Mã trạng thái:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.trangthaiMa }} - {{ getStatusName(selectedCode.trangthaiMa)}}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Mã trạng thái cũ:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.trangthaiCu }} - {{ getStatusName(selectedCode.trangthaiCu)}}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Trạng thái danh mục:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.trangthaiDm }}</label>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Ngày đóng mở:"
                                      label-cols-md="4"
                                      label-align="left"
                                      :horizontal="true">
                            <label class="col-form-label">{{ selectedCode.ngayDmo | formatDate }}</label>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
            <template #modal-footer="{ ok, cancel, hide }">
                <b-button type="button" variant="primary" :to="{ path: `/master-data/units/create?nbc=${selectedCode.ma}` }">
                    Chuyển đơn vị
                </b-button>
                <b-button type="button" variant="secondary" @click="cancel()">
                    Đóng
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import { validationMixin } from 'vuelidate'
    import { mixins } from '@/shared/mixins'
    import store from '@/store/index'

    export default {
        data() {
            return {
                gridOptions: {
                    fields: [
                        { key: 'ma', label: 'Mã quan hệ ngân sách', sortable: true, sortDirection: 'asc' },
                        { key: 'ten', label: 'Tên đơn vị', sortable: true },
                        { key: 'dvctTen', label: 'Đơn vị cấp trên', sortable: true },
                        { key: 'ngayTao', label: 'Ngày tạo', sortable: true },
                        { key: 'status', label: 'Trạng thái mã', sortable: true },
                    ],
                    sortBy: 'ma',
                },
                showGrid: false,
                searchForm: {
                    str: null,
                    trangThaiMa: '03',
                    startDate: null,
                    endDate: null
                },
                dmdcStatuses: [
                    { id: '01', text: 'Chờ xem xét' },
                    { id: '02', text: 'Huỷ phê duyệt' },
                    { id: '03', text: 'Đã phê duyệt' },
                    { id: '04', text: 'Tạm dừng' },
                    { id: '05', text: 'Đóng' },
                    { id: '06', text: 'Huỷ' },
                    { id: '07', text: 'Chờ phê duyệt' },
                    { id: '08', text: 'Hủy xem xét' },
                    { id: '09', text: 'Từ chối phê duyệt' },
                ],
                selectedCode: {

                }
            }
        },
        mounted() {
        },
        methods: {
            search() {
                this.$refs.nationalBudgetCodeTable.refresh();
            },
            getStatusName(ma) {
                var status = this.dmdcStatuses.find(x => x.id == ma);
                if (status) return status.text;
            },
            loadNationalBudgetCodeDetail(id) {
                var vm = this;
                this.$services.get(`master-data/national-budget-code-data/${id}`).done(data => vm.selectedCode = data);
            },
            resetModal() {
            },
            handleOk(bvModalEvt) {
                this.$route.push({ path: `/master-data/units/create?nbc=${this.selectedCode.ma}` });
            },
            cancel(bvModalEvt) {
                this.$bvModal.hide('modal-national-budget-code-detail');
            },
        }
    }
</script>